module.exports = __webpack_public_path__ + "img/visa.1e017c01.svg";